import React, { useState } from 'react';
import './CancelLink.css';
import { useAppContext } from '../../core/context';
import { useApi } from '../../platform/api/useApi';
import { useNavigation } from '../../platform/navigation/useNavigation';
import { useIframe } from '../../platform/iframe/useIframe';
import { useDevice } from '../../platform/device/useDevice';
import { redirect } from '../../core/api/redirect';

interface CancelLinkProps {
  children: React.ReactNode;
  'aria-label': string;
}

function CancelLink({ children, 'aria-label': ariaLabel }: CancelLinkProps): React.ReactNode {
  const [cancelling, setCancelling] = useState(false);
  const context = useAppContext();
  const apis = useApi();
  const navigation = useNavigation();
  const iframe = useIframe();
  const device = useDevice();
  const claims = context.claims;

  if (!claims) {
    return <></>;
  }

  const onClick = async (event: React.MouseEvent) => {
    event.preventDefault();

    if (!cancelling) {
      setCancelling(true);

      try {
        await apis.cancel(context);
      } finally {
        cancel();
      }
    }
  };

  const cancel = () =>
    redirect(
      claims.fallback,
      'REJECTED',
      claims.brand,
      claims.apiSource,
      device.isMobile,
      navigation,
      iframe
    );

  return (
    <a className="cancel-link" href={claims.fallback} onClick={onClick} aria-label={ariaLabel}>
      {children}
    </a>
  );
}

export default CancelLink;
